import {addPermissionToRoleSaga} from './add-permission-to-role';
import {changeSubordinateRoleSago} from './change-subordinate-role';
import {createAssociationRolesSaga} from './create-association-roles-saga';
import {createBreederSaga} from './create-breeder-saga';
import {createManagementAssociationSaga} from './create-management-association-saga';
import {createManagementBreederSaga} from './create-management-breeder-saga';
import {createManagementOrganizationSaga} from './create-management-organization-saga';
import {createManagementOtherSubjectSaga} from './create-management-other-subject-saga';
import {createOrganizationsSaga} from './create-organizations-saga';
import {createOtherSubjectsSaga} from './create-other-subjects-saga';
import {createPermissionSaga} from './create-permission-saga';
import {createRoleSaga} from './create-role-saga';
import {createUserContactSaga} from './create-user-contact';
import {createUserMembershipSaga} from './create-user-membership-saga';
import {deletePermissionSaga} from './delete-permission-saga';
import {deleteRoleSaga} from './delete-role-saga';
import {deleteUserContactSaga} from './delete-user-contact-saga';
import {updatePermissionSaga} from './edit-permission-saga';
import {updateRoleSaga} from './edit-role-saga';
import {updateUserContactSaga} from './edit-user-contact-saga';
import {appInfoSaga} from './get-app-info';
import {getAuthDiscriminatorOptionsSaga} from './get-auth-discriminator-options-saga';
import {getManagementAssociationDetailSaga} from './get-management-association-detail-saga';
import {getManagementAssociationsOptionsSaga} from './get-management-associations-options-saga';
import {getManagementAssociationsTableData} from './get-management-associations-table-data-saga';
import {getManagementBreederDetailSaga} from './get-management-breeder-detail-saga';
import {getManagementBreederFarmsSaga} from './get-management-breeders-farms-saga';
import {getManagementBreederOptionsSaga} from './get-management-breeders-options-saga';
import {getManagementBreederTableData} from './get-management-breeders-table-data-saga';
import {getManagementOrganizationCentersSaga} from './get-management-organization-centers-saga';
import {getManagementOrganizationDetailSaga} from './get-management-organization-detail-saga';
import {getManagementOrganizationFarmsSaga} from './get-management-organization-farms-saga';
import {getManagementOrganizationsOptionsSaga} from './get-management-organization-options-saga';
import {getManagementOrganizationsTableData} from './get-management-organizations-table-data-saga';
import {getManagementOtherSubjectDetailSaga} from './get-management-other-subject-detail-saga';
import {getManagementOtherSubjectsOptionsSaga} from './get-management-other-subject-options-saga';
import {getManagementOtherSubjectsTableData} from './get-management-other-subjects-table-data-saga';
import {getMemberOfSubjectsSaga} from './get-member-of-subjects-saga';
import {getOrganizationsSaga} from './get-organizations-saga';
import {getPermissionDetails} from './get-permission-details-saga';
import {getRolePermissionsV2Saga} from './get-role-permissions-saga';
import {getRoleSaga} from './get-role-saga';
import {getRoleUnassignedPermissionsV2Saga} from './get-role-unassigned-permissions-saga';
import {getRoles} from './get-roles-saga';
import {getSubordinateAssignedRolesSaga} from './get-subordinate-assigned-role-saga';
import {getSubordinateUnassignedRolesSaga} from './get-subordinate-unassigned-role-saga';
import {getUserAssociationsSaga} from './get-user-associations-saga';
import {getUserBreedersSaga} from './get-user-breeders';
import {getUserContactsSaga} from './get-user-contacts-saga';
import {getUserOtherSubjectRolesSaga} from './get-user-other-subject-roles-saga';
import {getUserSaga} from './get-user-saga';
import {removeAssociationRolesForUserSaga} from './remove-association-roles-for-user-saga';
import {removeBreederRolesForUserSaga} from './remove-breeder-roles-for-user-saga';
import {removeOrganizationRolesForUserSaga} from './remove-organization-roles-for-user-saga';
import {removeOtherSubjectRolesForUserSaga} from './remove-other-subject-roles-for-user-saga';
import {removePermissionFromRoleSaga} from './remove-permission-from-role';
import {removeUsersFromAssociationRole} from './remove-users-from-association-role-saga';
import {removeUsersFromBreederRole} from './remove-users-from-breeder-role-saga';
import {removeUsersFromOrganizationRole} from './remove-users-from-organization-role-saga';
import {removeUsersFromOtherSubjectRole} from './remove-users-from-other-subject-role-saga';
import {searchManagementAssociationsRolesSaga} from './search-management-associations-roles-saga';
import {searchManagementAssociationsUsersSaga} from './search-management-associations-users-saga';
import {searchManagementBreedersRolesSaga} from './search-management-breeders-roles-saga';
import {searchManagementBreedersUsersSaga} from './search-management-breeders-users-saga';
import {searchManagementOrganizationsRolesSaga} from './search-management-organization-roles-saga';
import {searchManagementOrganizationsUsersSaga} from './search-management-organization-users-saga';
import {searchManagementOtherSubjectsRolesSaga} from './search-management-other-subject-roles-saga';
import {searchManagementOtherSubjectsUsersSaga} from './search-management-other-subject-users-saga';
import {updateAssociationRolesSaga} from './update-association-roles-saga';
import {updateBreederSaga} from './update-breeder-saga';
import {updateManagementAssociationDetailSaga} from './update-management-association-detail-saga';
import {updateManagementBreederDetailSaga} from './update-management-breeder-detail-saga';
import {updateManagementOrganizationDetailSaga} from './update-management-organization-detail-saga';
import {updateManagementOtherSubjectDetailSaga} from './update-management-other-subject-detail-saga';
import {updateOrganizationsSaga} from './update-organizations-saga';
import {updateOtherSubjectsSaga} from './update-other-subjects-saga';
import {updateUserMembershipSaga} from './update-user-membership-saga';
import {validateManagementAssociationSaga} from './validate-management-association-saga';
import {validateManagementBreederSaga} from './validate-management-breeder-saga';
import {validateManagementOrganizationSaga} from './validate-management-organization-saga';
import {validateManagementOtherSubjectSaga} from './validate-management-other-subject-saga';
import {validatePermissionSaga} from './validate-permission-saga';
import {validateRoleSaga} from './validate-role-saga';

/** Complete saga registration for the admin module. */
export const adminSagas = [
    appInfoSaga,
    getAuthDiscriminatorOptionsSaga,
    updateBreederSaga,
    createBreederSaga,
    getManagementBreederOptionsSaga,
    createOrganizationsSaga,
    getOrganizationsSaga,
    createAssociationRolesSaga,
    createOtherSubjectsSaga,
    updateOtherSubjectsSaga,
    updateOrganizationsSaga,
    updateAssociationRolesSaga,
    createUserContactSaga,
    deleteUserContactSaga,
    updateUserContactSaga,
    getRolePermissionsV2Saga,
    getRoleUnassignedPermissionsV2Saga,
    removePermissionFromRoleSaga,
    addPermissionToRoleSaga,
    getPermissionDetails,
    deletePermissionSaga,
    updatePermissionSaga,
    validatePermissionSaga,
    createPermissionSaga,
    getRoles,
    deleteRoleSaga,
    createRoleSaga,
    validateRoleSaga,
    updateRoleSaga,
    getRoleSaga,
    getSubordinateAssignedRolesSaga,
    getSubordinateUnassignedRolesSaga,
    changeSubordinateRoleSago,
    getUserSaga,
    getMemberOfSubjectsSaga,
    updateUserMembershipSaga,
    createUserMembershipSaga,
    getUserContactsSaga,
    getUserAssociationsSaga,
    getUserOtherSubjectRolesSaga,
    getUserBreedersSaga,
    getManagementBreederTableData,
    getManagementBreederFarmsSaga,
    removeBreederRolesForUserSaga,
    removeUsersFromBreederRole,
    getManagementBreederDetailSaga,
    updateManagementBreederDetailSaga,
    createManagementBreederSaga,
    validateManagementBreederSaga,
    searchManagementBreedersRolesSaga,
    searchManagementBreedersUsersSaga,
    getManagementAssociationsOptionsSaga,
    getManagementAssociationsTableData,
    removeUsersFromAssociationRole,
    removeAssociationRolesForUserSaga,
    searchManagementAssociationsUsersSaga,
    searchManagementAssociationsRolesSaga,
    validateManagementAssociationSaga,
    createManagementAssociationSaga,
    getManagementAssociationDetailSaga,
    updateManagementAssociationDetailSaga,
    getManagementOtherSubjectsOptionsSaga,
    getManagementOtherSubjectsTableData,
    createManagementOtherSubjectSaga,
    getManagementOtherSubjectDetailSaga,
    removeOtherSubjectRolesForUserSaga,
    removeUsersFromOtherSubjectRole,
    searchManagementOtherSubjectsRolesSaga,
    searchManagementOtherSubjectsUsersSaga,
    updateManagementOtherSubjectDetailSaga,
    validateManagementOtherSubjectSaga,
    getManagementOrganizationsOptionsSaga,
    getManagementOrganizationsTableData,
    getManagementOrganizationFarmsSaga,
    getManagementOrganizationCentersSaga,
    createManagementOrganizationSaga,
    searchManagementOrganizationsUsersSaga,
    searchManagementOrganizationsRolesSaga,
    updateManagementOrganizationDetailSaga,
    getManagementOrganizationDetailSaga,
    validateManagementOrganizationSaga,
    removeOrganizationRolesForUserSaga,
    removeUsersFromOrganizationRole,
];
